export function newUppKonvaShapeId(): string {
    const c = globalThis.crypto;
    if (c && typeof c.randomUUID === 'function') {
        return c.randomUUID();
    }
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (ch) => {
        const n = (Math.random() * 16) | 0;
        const v = ch === 'x' ? n : (n & 0x3) | 0x8;
        return v.toString(16);
    });
}
